<template>
  <v-dialog v-model="visible" max-width="638" persistent>
    <v-card v-if="visible" class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <form
        class="form--custom"
        novalidate
        @submit.prevent="handleSubmit"
      >
        <v-card-text class="px-4 pt-0 pb-3">
          <p v-html="$t(`${namespace}.text`)" />
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer/>

          <a
            v-if="!isLoading"
            href="#"
            class="text--normal accent--text mr-4"
            color="accent"
            flat
            round
            @click.prevent="close(null)"
          >
            {{ $t('Common.cancel') }}
          </a>

          <v-btn
            type="submit"
            :loading="isLoading"
            :disabled="isLoading"
            color="accent"
            depressed
            round
          >
            {{ $t(`${namespace}.confirm`) }}
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { isArray } from 'utils/functions'

export default {
  name: 'ApproveIncentiveDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      namespace: 'Views.IncentivesPage.approveIncentiveDialog',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close (reload = null) {
      this.$emit('close', reload)
    },

    isValidArray (val) {
      return isArray(val)
    },

    async handleSubmit () {
      this.isLoading = true

      try {
        const incentivesId = this.data && this.data.id ? this.data.id : null
        const { data: res } = await this.$apiService.incentives.approved({
          incentivesIds: [incentivesId]
        })

        if (res && res.content && this.isValidArray(res.content.errors)) {
          const message = this.isValidArray(res.content.errors[0].messageErrors)
            ? res.content.errors[0].messageErrors[0]
            : this.$t(`${this.namespace}.error`)

          this.isLoading = false
          return this.showAlert({
            type: 'error',
            message,
            timeout: 10000
          })
        }

        this.close(true)
        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.success`)
        })
      } catch (err) {
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.error`),
          timeout: 10000
        })
      }

      this.isLoading = false
    }
  }
}
</script>
